import React, { PropsWithChildren } from "react";

type DialogHeaderProps = PropsWithChildren<{
  id: string;
}>;

export default function DialogHeader({ id, children }: DialogHeaderProps) {
  return (
    <div className="modal-header">
      <h1 className="modal-title fs-5" id={id}>
        {children}
      </h1>
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      />
    </div>
  );
}
